<template>
  <!--  Generated from Add_Edit_w_Lookups template-->
  <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
    <v-card class="elevation-3">
      <v-card-title class="primary text-h5 white--text">
        {{ headerText }}
      </v-card-title>
      <v-card-text class="pa-4">
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Year"
              v-model="selectedLuSession.Year"
              type="number"
              :rules="[(v) => parseFloat(v) == parseFloat(v) || 'required']"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Title"
              v-model="selectedLuSession.Title"
              :rules="[(v) => !!v || 'required']"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-checkbox
              label="Is Active"
              v-model="selectedLuSession.IsActive"
              :rules="[(v) => v === true || v === false || 'required']"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <BaseDatePickerWithText
              label="Session Start Date mm/dd/yyyy"
              v-model="selectedLuSession.SessionStartDate"
              :rules="[(v) => !!v || 'required']"
            ></BaseDatePickerWithText>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <BaseDatePickerWithText
              label="Session End Date mm/dd/yyyy"
              v-model="selectedLuSession.SessionEndDate"
              :rules="[(v) => !!v || 'required']"
            ></BaseDatePickerWithText>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Special Session Value"
              v-model="selectedLuSession.SpecialSessionValue"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-checkbox
              label="Has Session Landing Page"
              v-model="selectedLuSession.HasSessionLandingPage"
              :rules="[(v) => v === true || v === false || 'required']"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="saveLuSessionDetails" :disabled="saving" color="primary"
          >Save</v-btn
        >
        <v-btn v-if="inDialog" outlined color="primary" @click="cancelEntry"
          >Cancel</v-btn
        >

        <v-btn
          class="ml-auto"
          v-if="selectedLuSession.Id > 0"
          @click="refreshBills"
          color="primary"
          >Refresh Bills</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LuSession from '@classes/LuSession'
//templateTODO: import lookup components you plan to use
export default {
  components: {
    //templateTodo: define lookup components you are using
  },
  props: {
    dialog: {
      type: Boolean,
      default: null,
    },
  },
  data: () => ({
    valid: true,
    selectedLuSession: new LuSession(),
    headerText: 'LuSession',
  }),
  created() {},
  computed: {
    ...get('luSession', ['saving']),
    inDialog() {
      if (this.dialog === false || this.dialog === true) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    ...call('luSession', ['saveLuSession', 'updateSessionBills']),
    async validate() {
      await this.$refs.form.validate()
    },
    editLuSession(entry) {
      this.selectedLuSession = new LuSession(entry)
      this.headerText = 'Edit Session'
    },
    addLuSession() {
      this.headerText = 'Insert Session'
      this.selectedLuSession = new LuSession()
    },
    async refreshBills() {
      let res = await this.updateSessionBills(this.selectedLuSession.Id)
      this.$emit('refresh')
    },
    async saveLuSessionDetails() {
      await this.validate()
      if (this.valid) {
        //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
        try {
          let res = await this.saveLuSession(
            this.selectedLuSession.removeRelated()
          )
          this.$emit('refresh')
          this.$emit('itemAdded', res.data)
          this.selectedLuSession = new LuSession()
          this.$refs.form.resetValidation()
        } catch (err) {}
        this.$emit('update:dialog', false)
      }
    },
    cancelEntry() {
      this.selectedLuSession = new LuSession()
      this.$refs.form.resetValidation()
      this.$emit('update:dialog', false)
    },
  },
}
</script>
<style></style>
